import { render, staticRenderFns } from "./canvasPie.vue?vue&type=template&id=0b801296&scoped=true&"
import script from "./canvasPie.vue?vue&type=script&lang=js&"
export * from "./canvasPie.vue?vue&type=script&lang=js&"
import style0 from "./canvasPie.vue?vue&type=style&index=0&id=0b801296&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b801296",
  null
  
)

export default component.exports